module.exports = __webpack_public_path__ + "img/c6a10b11ffb89ded75a3dd4c77d6fa07.png";